import Vue from 'vue'

export default {
  getMetaTags ({ commit }) {
    return Vue.axios.get('/metatags')
      .then(({ data }) => commit('ADD_META_TAGS', data))
  },
  addMetaTagSchema ({ commit }, metaTag) {
    commit('ADD_META_TAG_SCHEMA', metaTag)
  },
  addMetaTag ({ commit }, metaTag) {
    return Vue.axios.post('/metatags', { metaTag })
      .then(({ data }) => commit('ADD_NEW_META_TAG', data))
  },
  updateMetaTag ({ commit }, metaTag) {
    return Vue.axios.put('/metatags', { metaTag })
  },
  deleteMetaTag ({ commit }, metaTagId) {
    return Vue.axios.delete(`/metatags/${metaTagId}`)
      .then(() => commit('DELETE_META_TAG', metaTagId))
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/metaTags.js